import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import PropTypes from 'prop-types';
import { CircularProgressbar } from 'react-circular-progressbar';

import { formatNumberWithCommas } from 'components/helpers';
import {
  Row, Column1, Column2, ExpandIcon, ScoreWrapper, ScoreCircle, ScoreText, UnitPreview, UnitPreviewText, CloseButton, Thumbnail, ContentArea, SalePrice,
} from './styles';

const UnitPreviewOverlay = ({ show, values, setShowUnitPreview, setShowImageCarousel }) => {
  if (values) {
    const {
      color, inspectionHeaders, location, mileage, pictureURLs, saleAmount, saleDate, score, soldHighBid,
    } = values;

    return (
      <UnitPreview animate={{ opacity: show ? 1 : 0 }}>
        <Row>
          <Column1>
            <Thumbnail border="0" src={`${pictureURLs[0].url}&width=200`} onClick={() => setShowImageCarousel(true)} />
            <ExpandIcon>
              <FontAwesomeIcon onClick={() => setShowUnitPreview()} icon="expand-arrows-alt" color="black" size="1x" />
            </ExpandIcon>
          </Column1>
          <Column2>
            <ContentArea>
              <ScoreWrapper>
                <ScoreCircle>
                  <CircularProgressbar value={score} />
                </ScoreCircle>
                <ScoreText>{score}</ScoreText>
              </ScoreWrapper>
              <SalePrice>
                $
                {formatNumberWithCommas(saleAmount)}
              </SalePrice>
              <UnitPreviewText>
                {`${formatNumberWithCommas(mileage)} Mi`}
              </UnitPreviewText>
              <UnitPreviewText>
                {color}
              </UnitPreviewText>
              <UnitPreviewText>
                {moment(saleDate).format('MM/DD/YYYY').toString()}
              </UnitPreviewText>
              <UnitPreviewText>
                {location}
              </UnitPreviewText>
            </ContentArea>
          </Column2>
        </Row>
        <CloseButton>
          <FontAwesomeIcon onClick={() => setShowUnitPreview(false)} icon="times" color="black" size="1x" />
        </CloseButton>
      </UnitPreview>
    );
  }

  return null;
};

UnitPreviewOverlay.propTypes = {
  show: PropTypes.bool,
  values: PropTypes.object,
  setShowUnitPreview: PropTypes.func.isRequired,
};

UnitPreviewOverlay.defaultProps = {
  show: false,
  values: null,
};

export default UnitPreviewOverlay;
